import { render, staticRenderFns } from "./WorkoutVideo.vue?vue&type=template&id=1fe051c2&scoped=true"
import script from "./WorkoutVideo.vue?vue&type=script&lang=js"
export * from "./WorkoutVideo.vue?vue&type=script&lang=js"
import style0 from "./WorkoutVideo.vue?vue&type=style&index=0&id=1fe051c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe051c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
